import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { Lecturer, ServerResponse, UploadImage } from 'src/api';
import { TR } from 'src/TextRes';
import ErrorBox from '../../components/errorBox/ErrorBox';
import ErrorMessage from '../../components/errorMessage/ErrorMessage';
import FAIcon from '../fAIcon/FAIcon';
import ImageChooserSingle from '../imageChooser/ImageChooserSingle';
import ImagePlaceholder from '../imageChooser/ImagePlaceholder';
import './CPLecturerComponent.css';

interface CPLecturerComponentProps {
    cancelHandler: () => void;
    changeHandler: (editValue: string, field: string) => void;
    changeImage: (image?: UploadImage) => void;
    imageData?: string;
    imageDelete: boolean;
    editState: EditState;
    entryId: number;
    error: boolean;
    errorClass: (fieldname: string) => string;
    errors: string[];
    serverResponse: ServerResponse | undefined;
    lecturer: Lecturer;
    editValue: Lecturer;
    saveHandler: (entryId: number) => void;
    selectEntry: (entryId: number, selectionMethod: SelectionMethod) => void;
}

export enum EditState {
    None,
    This,
    Other,
}

export enum SelectionMethod {
    Delete,
    Edit,
}

export const CPLecturerComponent = (props: CPLecturerComponentProps) => {
    if (props.editState === EditState.None || props.editState === EditState.Other) {
        return (
            <>
                <Row className={'mb-50 ph-15'}>
                    <Col className={'CPLecturerComponent'} md={12}>
                        <Row>
                            <Col md={2}>
                                <Row>
                                    <Col>
                                        <ImagePlaceholder image={props.lecturer.Image} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={9}>
                                <Row>
                                    <Col md={2}>
                                        <Label className="font-weight-bold">{TR.cPLecturerComponent_salutation}</Label>
                                        <p>{props.lecturer.Salutation}</p>
                                    </Col>
                                    <Col md={2}>
                                        <Label className="font-weight-bold">{TR.cPLecturerComponent_title}</Label>
                                        <p>{props.lecturer.Title}</p>
                                    </Col>
                                    <Col md={4}>
                                        <Label className="font-weight-bold">{TR.cPLecturerComponent_first_name}</Label>
                                        <p>{props.lecturer.FirstName}</p>
                                    </Col>
                                    <Col md={4}>
                                        <Label className="font-weight-bold">{TR.cPLecturerComponent_last_name}</Label>
                                        <p>{props.lecturer.LastName}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Label className="font-weight-bold">{TR.cPLecturerComponent_description}</Label>
                                        <p style={{ whiteSpace: 'pre-line' }}>{props.lecturer.Description}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Label className="font-weight-bold">
                                            {TR.cPLecturerComponent_lecturer_website}
                                        </Label>
                                        <p>
                                            <a href={props.lecturer.ProfileURL} target={'_blank'}>
                                                {props.lecturer.ProfileURL}
                                            </a>
                                        </p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={1}>
                                {props.editState === EditState.None && (
                                    <>
                                        <Row className={'optionButtons'}>
                                            <Col>
                                                <a
                                                    className="iconButton"
                                                    onClick={() => {
                                                        props.selectEntry(props.entryId, SelectionMethod.Edit);
                                                    }}
                                                >
                                                    <FAIcon icon="edit" />
                                                </a>
                                            </Col>
                                        </Row>
                                        <Row className={'optionButtons'}>
                                            <Col>
                                                <a
                                                    className="iconButton"
                                                    onClick={() => {
                                                        props.selectEntry(props.entryId, SelectionMethod.Delete);
                                                    }}
                                                >
                                                    <FAIcon icon="trash" />
                                                </a>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        );
    } else {
        const error = props.error;

        return (
            <>
                <Row className={'ph-15'}>
                    <Col className={'CPLecturerComponent'} md={12}>
                        <Row>
                            <Col md={2}>
                                <Row>
                                    <Col>
                                        <ImageChooserSingle
                                            imageDelete={props.imageDelete}
                                            onDelete={(image: UploadImage) => {
                                                props.changeImage(image);
                                            }}
                                            onFileChosen={(image: UploadImage) => {
                                                props.changeImage(image);
                                            }}
                                            image={props.editValue.Image}
                                            imageData={props.imageData}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={10}>
                                <Row>
                                    <Col md={2}>
                                        <Label className={error ? props.errorClass('Salutation') : 'font-weight-bold'}>
                                            {TR.cPLecturerComponent_salutation}
                                        </Label>
                                        <Input
                                            type="select"
                                            name="salutation"
                                            value={props.editValue.Salutation}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'Salutation')}
                                        >
                                            <option value="">{''}</option>
                                            <option value="Frau">Frau</option>
                                            <option value="Herr">Herr</option>
                                        </Input>
                                    </Col>
                                    <Col md={2}>
                                        <Label className={error ? props.errorClass('Title') : 'font-weight-bold'}>
                                            {TR.cPLecturerComponent_title}
                                        </Label>
                                        <Input
                                            type="text"
                                            name="title"
                                            value={props.editValue.Title}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'Title')}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label className={error ? props.errorClass('Firstname') : 'font-weight-bold'}>
                                            {TR.cPLecturerComponent_first_name}
                                        </Label>
                                        <Input
                                            name={'firstName'}
                                            value={props.editValue.FirstName}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'FirstName')}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label className={error ? props.errorClass('Lastname') : 'font-weight-bold'}>
                                            {TR.cPLecturerComponent_last_name}
                                        </Label>
                                        <Input
                                            name={'lastName'}
                                            value={props.editValue.LastName}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'LastName')}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Label className={'font-weight-bold h4edit'}>
                                            {TR.cPLecturerComponent_description}
                                        </Label>
                                        <TextareaAutosize
                                            style={{
                                                maxHeight: 200,
                                                minHeight: 100,
                                                whiteSpace: 'pre-line',
                                                width: '100%',
                                            }}
                                            autoFocus={true}
                                            name={'description'}
                                            value={props.editValue.Description}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'Description')}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Label className={'font-weight-bold'}>Dozenten Website</Label>
                                        <Input
                                            name={'profileURL'}
                                            value={props.editValue.ProfileURL}
                                            onChange={(e) => props.changeHandler(e.currentTarget.value, 'ProfileURL')}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {error === true && (
                    <Row>
                        <Col>
                            <>
                                <ErrorBox serverResponse={props.serverResponse} />
                                <ErrorMessage errors={props.errors} />
                            </>
                        </Col>
                    </Row>
                )}
                <Row className={'optionButtons mb-50'}>
                    <Col md={12} className="text-right">
                        <Button className="mt-2 mb-1 mr-1" size="sm" onClick={props.cancelHandler}>
                            {TR.cPLecturerComponent_cancel}
                        </Button>
                        <Button className="mt-2 mb-1" size="sm" onClick={() => props.saveHandler(props.entryId)}>
                            {TR.cPLecturerComponent_save}
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/cpLecturerComponent/CPLecturerComponent.tsx